import { render, staticRenderFns } from "./FaqCategory.vue?vue&type=template&id=56e7b4f9&scoped=true"
import script from "./FaqCategory.vue?vue&type=script&lang=js"
export * from "./FaqCategory.vue?vue&type=script&lang=js"
import style0 from "./FaqCategory.vue?vue&type=style&index=0&id=56e7b4f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7b4f9",
  null
  
)

export default component.exports